import { Theme, createStyles, makeStyles } from '../../../MaterialUI'

export default makeStyles((theme: Theme) =>
  createStyles({
    picture: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      borderRadius: '20px'
    },
    pictureSmall: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      borderRadius: '20px'
    },
    icon: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      background: theme.palette.background.default,
      borderStyle: 'solid',
      borderWidth: '4px',
      borderColor: 'var(--primary-outlined-resting-border)',
      borderRadius: '20px'
    },
    iconSmall: {
      width: theme.spacing(7),
      height: theme.spacing(7),
      background: theme.palette.background.default,
      borderStyle: 'solid',
      borderWidth: '4px',
      borderColor: 'var(--primary-outlined-resting-border)',
      borderRadius: '20px'
    },
    personIcon: {
      color: 'var(--primary-outlined-resting-border)',
      fontSize: theme.spacing(5)
    },
    badge: {
      width: '20px',
      height: '20px',
      top: '0px',
      left: '6px'
    },
    navigate: {
      display: 'grid',
      justifyContent: 'center',
      alignItems: 'center'
    },
    button: {
      height: '42px'
    }
  })
)
